import { motion } from "framer-motion";
import { Globe2, Search, Wrench } from "lucide-react";

const items = [
  {
    icon: Globe2,
    problem: "Verkkosivut vanhentuneet tai puuttuvat?",
    solution: "Rakennamme moderni yrityssivusto viikossa – valmis paketti kiinteällä hinnalla, ilman koodausosaamista.",
  },
  {
    icon: Search,
    problem: "Uudet asiakkaat eivät löydä sinua?",
    solution: "Google-optimoitu, nopea ja mobiilioptimoitu sivu tuo sinulle uusia yhteydenottoja ja kauppoja.",
  },
  {
    icon: Wrench,
    problem: "Ei aikaa tai osaamista päivittää sivuja?",
    solution: "Jatkuva ylläpito kuukausihintaan – me hoidamme muutokset, tietoturvan ja varmuuskopiot puolestasi.",
  },
];

export default function ProblemSolution() {
  return (
    <section className="md-section relative" data-testid="problem-solution-section" id="ongelma">
      <div className="md-container">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-12 md:mb-16"
        >
          <span className="md-eyebrow">Ongelma / Ratkaisu</span>
          <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            Tunnistatko nämä <span className="text-[#00E5FF]">kipupisteet?</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <motion.div
              key={it.problem}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="md-card p-8 group hover:border-[#0066FF]/40 transition-colors"
              data-testid={`pain-point-${i + 1}`}
            >
              <div className="h-12 w-12 rounded-2xl bg-[#0066FF]/15 border border-[#0066FF]/30 grid place-items-center text-[#00E5FF] group-hover:bg-[#0066FF]/25 transition-colors">
                <it.icon size={22} strokeWidth={1.75} />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-white">{it.problem}</h3>
              <p className="mt-3 text-white/60 leading-relaxed">{it.solution}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
